import React from 'react';
// Import the corresponding CSS file
import './ContactUs.css';
import DefaultData from '../../CompanyData/DefaultData';

const ContactUs = () => {
    // Data for office locations
    const officesData = [
        {
            name: 'BABA TRAVEL AND TOURISM (India)',
            addressLines: [
                '5-9-246/C, Shop No.1, SS Centre Building',
                'Opp St, Georges Grammar School,',
                'Abids, Hyderabad, Telangana 500001'
            ],
            icon: 'ri-map-pin-2-line'
        },
        {
            name: 'BABA TRAVEL AND TOURISM (India)',
            addressLines: [
                'Jayaprakash Narayan Road,',
                'Girmajipet,',
                'Warangal, Telangana 506002'
            ],
            icon: 'ri-map-pin-2-line'
        }
    ];

    // Hero image for the contact page
    const heroStyle = {
        backgroundImage: `url('/assets/images/ContactUs.png')`,
    };

    return (
        <div className="main-content">
            <div className="contact-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Contact Us</h1>
                        <p className="hero-subheading">We're here to help. Reach out to us anytime.</p>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">

                    {/* Top Contact Info Box */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="support-box text-center">
                                <i className="ri-customer-service-2-line support-icon"></i>
                                <h4>For Customer Support & Queries</h4>
                                <p>Get in touch with our dedicated support team.</p>
                                <a href={"mailto:" + DefaultData?.DEFAULTCOMPANYEMAIL} className="support-email">{DefaultData?.DEFAULTCOMPANYEMAIL}</a>
                                <p>{DefaultData?.DEFAULTCOMPANYPHONENUMBER}</p>
                            </div>
                        </div>
                    </div>

                    {/* Worldwide Offices Section */}
                    <div className="offices-section">
                        <h2 className="section-title">Worldwide Offices</h2>
                        <div className="row g-4">
                            {officesData.map((office, index) => (
                                <div className="col-lg-4 col-md-6" key={index}>
                                    <div className="office-card h-100">
                                        <div className="office-icon">
                                            <i className={office.icon}></i>
                                        </div>
                                        <h5 className="office-name">{office.name}</h5>
                                        <address className="office-address">
                                            {office.addressLines.map((line, i) => (
                                                <span key={i}>{line}<br /></span>
                                            ))}
                                        </address>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Google Map Section */}
                    <div className="map-section">
                        <h2 className="section-title">Our Hyderabad Location</h2>
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.92425870193!2d79.5990928!3d17.9822605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a33455e93f08e91%3A0xb88ce7813083371e!2sBABA%20TRAVEL%20AND%20TOURISM!5e0!3m2!1sen!2sin!4v1765346492965!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ContactUs;